var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "base-table-item" },
    [
      _vm.item.type === "text"
        ? _c(
            "div",
            {
              staticClass: "text_hidden",
              attrs: {
                title: _vm.item.render
                  ? _vm.item.render(_vm.renderData)
                  : _vm.renderData[_vm.item.prop],
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.item.render
                      ? _vm.item.render(_vm.renderData)
                      : _vm.renderData[_vm.item.prop]
                  ) +
                  " "
              ),
            ]
          )
        : _vm._e(),
      _vm.item.type === "multText"
        ? _c(
            "div",
            {
              attrs: {
                title: _vm.item.render
                  ? _vm.item.render(_vm.renderData)
                  : _vm.renderData[_vm.item.prop],
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.item.render
                      ? _vm.item.render(_vm.renderData)
                      : _vm.renderData[_vm.item.prop]
                  ) +
                  " "
              ),
            ]
          )
        : _vm._e(),
      _vm.item.type === "tag"
        ? _c("el-tag", [
            _vm._v(
              _vm._s(
                _vm.item.render
                  ? _vm.item.render(_vm.renderData)
                  : _vm.renderData[_vm.item.prop]
              )
            ),
          ])
        : _vm._e(),
      _vm.item.type === "avatar"
        ? [
            _c("div", [
              _c("div", { staticClass: "avatar-inner" }, [
                _c("img", {
                  staticClass: "avatar",
                  attrs: { src: _vm.renderData[_vm.item.prop] },
                }),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm.item.type === "select"
        ? _c("div", { staticClass: "el-tag" }, [
            _vm._v(
              _vm._s(
                _vm.getSelectData(
                  _vm.renderData[_vm.item.prop],
                  _vm.item.options
                )
              )
            ),
          ])
        : _vm._e(),
      _vm.item.type === "popover"
        ? [
            _vm.renderData[_vm.item.prop] &&
            _vm.renderData[_vm.item.prop].length > 10
              ? [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: _vm.renderData[_vm.item.prop],
                        placement: "top",
                        "popper-class": "mw_400",
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.renderData[_vm.item.prop].length > 10
                                ? `${_vm.renderData[_vm.item.prop].slice(
                                    0,
                                    10
                                  )}...`
                                : _vm.renderData[_vm.item.prop].slice(0, 10)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                ]
              : _c("span", [_vm._v(_vm._s(_vm.renderData[_vm.item.prop]))]),
          ]
        : _vm._e(),
      _vm.item.type === "popoverLang"
        ? [
            _c(
              "el-popover",
              {
                attrs: {
                  placement: _vm.item.placement || "top-start",
                  width: _vm.item.width || 400,
                  trigger: "hover",
                  content: _vm.langContent,
                },
              },
              [
                _c("div", { attrs: { slot: "reference" }, slot: "reference" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.langContent.length > 20
                          ? `${_vm.langContent.slice(0, 20)}...`
                          : _vm.langContent.slice(0, 20)
                      ) +
                      " "
                  ),
                ]),
              ]
            ),
          ]
        : _vm._e(),
      _vm.item.type === "phone"
        ? [
            _c("watchPhoneNumber", {
              attrs: {
                "default-value": _vm.renderData[_vm.item.prop],
                copy: _vm.item.copy,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }